import { Timezone } from "@/constants/dateTime";
import { DatasetFilter, FilterOption } from "@/types/dataset";

import SavedFilterItem from "./SavedFilterItem";

type SavedFiltersListProps = {
  filters: DatasetFilter[];
  filterOptions: FilterOption[];
  datasetId?: string;
  timezone?: Timezone;
  onEdit?: (filter: DatasetFilter) => void;
  onDelete?: (filter: DatasetFilter) => void;
  onUpdateFilter?: (updatedFilter: DatasetFilter) => void;
};

const SavedFiltersList = ({
  filterOptions,
  filters,
  datasetId,
  timezone,
  onEdit,
  onDelete,
  onUpdateFilter
}: SavedFiltersListProps) => {
  return (
    <div className="space-y-3 font-sans" data-testid="saved-filters-list">
      {filters.map((filter) => (
        <SavedFilterItem
          key={`${filter.filterId}_${filter.attributeCode ?? ""}`}
          filter={filter}
          filterOptions={filterOptions}
          datasetId={datasetId}
          timezone={timezone}
          allSavedFilters={filters}
          onEdit={onEdit}
          onDelete={onDelete}
          onUpdateFilter={onUpdateFilter}
        />
      ))}
    </div>
  );
};

export default SavedFiltersList;
